import {
    Body,
    Button,
    Collapsible,
    CollapsibleMethods,
    colors,
    Input,
    Spacer,
} from '@spritz-finance/ui'
import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Row } from '../../../components/Layout/Row'
import { cssVar } from '../../../theme/utils'
import { useStoreReferralCode } from './useStoreReferralCode'

const SuccessContainer = styled.div`
    background: var(--surface-3, ${colors.seaSpray[50]});
    padding: 8px 16px;
    border-radius: 10px;
`

const ReferralCodeLink = styled.span`
    position: relative;
    background-image: linear-gradient(90deg, #ff5c00 0%, #ff9a68 40.35%, #6f51f9 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    &:hover {
        cursor: pointer;
    }

    &::before {
        content: '';
        position: absolute;
        top: 100%;
        width: 100%;
        left: 0;
        height: 1px;
        border-radius: 2px;
        background: linear-gradient(90deg, #ff5c00 0%, #ff9a68 40.35%, #6f51f9 100%);
    }
`

const StyledRow = styled(Row)`
    > div:first-child {
        flex: 1;
    }
`

const useValidateCode = () => {
    const [validating, setValidating] = useState(false)

    // @todo - validate code on backend

    const validate = async (code: string) => {
        if (!code || code.length === 0) return false
        return true
    }

    return { validate, validating }
}

export const ReferralCode = () => {
    const { alreadyApplied, storeCode, referralCode: existingCode } = useStoreReferralCode()
    const [code, setCode] = useState('')
    const [applied, setApplied] = useState(alreadyApplied)
    const action = useRef<CollapsibleMethods>(null)
    const { validate, validating } = useValidateCode()

    useEffect(() => {
        if (!alreadyApplied) return
        if (existingCode && existingCode.length > 0) setCode(existingCode)
    }, [alreadyApplied, existingCode])

    const showAction = () => action.current?.toggle()

    const handleApply = async () => {
        if (code.length === 0 || applied) return
        const valid = await validate(code)
        if (valid) {
            storeCode(code)
            setApplied(true)
        }
    }

    return (
        <>
            <Row align="center">
                <Body.Med size={14}>
                    Sign up for a Spritz account. Have a{' '}
                    <ReferralCodeLink onClick={showAction}>
                        <Body.Bold size={14}>referral code?</Body.Bold>
                    </ReferralCodeLink>
                </Body.Med>
            </Row>
            {!applied && (
                <Collapsible ref={action} defaultOpen={false}>
                    <Spacer height={16} />
                    <StyledRow>
                        <Input
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="Enter referral code"
                        />
                        <Spacer width={8} />
                        <Button.CTA onClick={handleApply} responsive loading={validating}>
                            Apply
                        </Button.CTA>
                    </StyledRow>
                </Collapsible>
            )}
            {applied && (
                <>
                    <Spacer height={16} />
                    <SuccessContainer>
                        <Row align="center">
                            <Body.Bold
                                size={14}
                                color={cssVar('--text-success', colors.seaSpray[75])}
                            >
                                Referral code {code} applied
                            </Body.Bold>
                        </Row>
                    </SuccessContainer>
                </>
            )}
            <Spacer height={24} />
        </>
    )
}
